import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./ProfileSection')));

const ProfileRoutes = [
	{ path: '/dashboard/profile', element: <Analytics />, auth: authRoles.admin },
];

export default ProfileRoutes;
